// Mock data for Profab website

export const services = [
{
  id: 1,
  title: 'Steel Fabrication',
  description: 'Custom steel fabrication services for commercial and industrial projects. Precision cutting, forming, and assembly.',
  icon: 'Wrench',
  image: 'https://images.unsplash.com/photo-1499815022134-5a333f5a299c'
},
{
  id: 2,
  title: 'Structural Welding',
  description: 'Certified welding services for structural steel, pipelines, and heavy equipment. Quality workmanship guaranteed.',
  icon: 'Flame',
  image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122'
},
{
  id: 3,
  title: 'Custom Metal Work',
  description: 'Architectural metalwork, railings, stairs, and decorative metal elements. Bringing your vision to life.',
  icon: 'Hammer',
  image: 'https://images.unsplash.com/photo-1529479627062-5f1f0b88912a'
},
{
  id: 4,
  title: 'Installation Services',
  description: 'Professional installation of fabricated components. On-time delivery and expert site management.',
  icon: 'HardHat',
  image: 'https://images.unsplash.com/uploads/14123892966835548e7bd/14369636'
},
{
  id: 5,
  title: 'Cladding',
  description: 'Expert metal cladding solutions for exterior and interior applications. Durable, weather-resistant panels with superior finish quality.',
  icon: 'Layers',
  image: 'https://images.pexels.com/photos/36689943/pexels-photo-36689943.jpeg'
},
{
  id: 6,
  title: 'Maintenance & Repair',
  description: 'Ongoing maintenance and repair services for metal structures and equipment. Fast response times.',
  icon: 'Settings',
  image: 'https://images.unsplash.com/photo-1741021632650-162065ae2b0d'
}];


export const projects = [
{
  id: 1,
  title: 'BIAL - Blue Dart Cargo',
  category: 'Commercial',
  description: 'ACP Cladding: 46,000 Sq Feet | Semi Unitised Glazing: 12,300 Sq Feet | Aluminium Windows: 23,000 Sq Feet',
  image: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/mbx7b9c5_WhatsApp%20Image%202026-04-15%20at%202.27.33%20PM.jpeg',
  location: 'BIAL, Bangalore'
},
{
  id: 2,
  title: 'BIAL Air India Cargo Section',
  category: 'Commercial',
  description: 'Aluminium Windows: 12,000 Sq Feet | Glazing: 9,500 Sq Feet | ACP Cladding: 6,500 Sq Feet',
  image: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/eat89gtp_WhatsApp%20Image%202026-04-15%20at%202.27.33%20PM%20%282%29.jpeg',
  location: 'BIAL, Bangalore'
},
{
  id: 3,
  title: 'The Ottera Hotel - Electronic City',
  category: 'Commercial',
  description: 'Premium hotel architectural cladding and facade work featuring modern design elements.',
  image: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/5nfm6kar_the-oterra-electronic-city-phase-1-bangalore-hotels-0mw48nop1d-250%20%281%29.webp',
  location: 'Electronic City, Bangalore'
},
{
  id: 4,
  title: 'Strides Arcolab',
  category: 'Industrial',
  description: 'Pharmaceutical manufacturing facility featuring specialized industrial cladding and clean-room compatible glazing systems.',
  image: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/eeqovz6q_images.jpg',
  location: 'Bangalore'
},
{
  id: 5,
  title: 'Ashok Leyland - Chennai',
  category: 'Commercial',
  description: 'Stainless Steel Cladding: 67,000 Sq Feet | Semi Unitised Glazing: 90,000 Sq Feet',
  image: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/ttlbjtj1_WhatsApp%20Image%202026-04-15%20at%202.27.32%20PM%20%281%29.jpeg',
  location: 'Chennai'
},
{
  id: 6,
  title: 'BMW Showroom - Chennai',
  category: 'Commercial',
  description: 'Premium automotive showroom featuring architectural ACP cladding and structural glazing systems.',
  image: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/5x09cqd7_WhatsApp%20Image%202026-04-15%20at%202.27.33%20PM%20%285%29.jpeg',
  location: 'Chennai'
}];


export const testimonials = [
{
  id: 1,
  name: 'Michael Rodriguez',
  company: 'Apex Construction Inc.',
  text: 'Profab delivered exceptional quality on our warehouse project. Their attention to detail and professionalism exceeded expectations.',
  rating: 5
},
{
  id: 2,
  name: 'Sarah Chen',
  company: 'Industrial Solutions Group',
  text: 'Outstanding work from start to finish. The team was responsive, skilled, and completed everything on schedule.',
  rating: 5
},
{
  id: 3,
  name: 'David Thompson',
  company: 'Metro Development Corp.',
  text: 'Profab has been our go-to fabrication partner for 3 years. Consistently reliable and high-quality results.',
  rating: 5
}];


export const teamMembers = [
{
  id: 1,
  name: "Arifulla Shariff",
  role: 'Founder & CEO',
  bio: "Over 20 years of experience in steel fabrication and construction management.",
  image: 'https://images.unsplash.com/photo-1774600166818-e554a4d4c376'
},
{
  id: 2,
  name: 'Maria Garcia',
  role: 'Operations Manager',
  bio: 'Expert in project coordination and quality control with 15 years in the industry.',
  image: 'https://images.unsplash.com/photo-1774600166818-e554a4d4c376'
},
{
  id: 3,
  name: 'Robert Chang',
  role: 'Lead Fabricator',
  bio: 'Master craftsman specializing in precision metalwork and custom fabrication.',
  image: 'https://images.unsplash.com/photo-1774600166818-e554a4d4c376'
}];


export const companyInfo = {
  mission: 'To deliver precision-engineered metal fabrication solutions that exceed industry standards and client expectations.',
  vision: 'Building the future through innovation, quality craftsmanship, and unwavering commitment to excellence.',
  values: [
  {
    title: 'Quality',
    description: 'We never compromise on the quality of our work. Every project receives meticulous attention to detail.',
    icon: 'Award'
  },
  {
    title: 'Reliability',
    description: 'On-time delivery and consistent results you can count on. Your deadlines are our priority.',
    icon: 'Shield'
  },
  {
    title: 'Innovation',
    description: 'Embracing cutting-edge technology and techniques to deliver superior fabrication solutions.',
    icon: 'Lightbulb'
  },
  {
    title: 'Safety',
    description: 'Maintaining the highest safety standards in every aspect of our operations.',
    icon: 'ShieldCheck'
  }],

  stats: [
  { label: 'Years of Experience', value: "20+" },
  { label: 'Projects Completed', value: "200+" },
  { label: 'Happy Clients', value: "100+" },
  { label: "Average rating", value: "4.7\u2605" }]

};


export const metroMaintenanceServices = [
{
  id: 1,
  title: 'Structural Maintenance',
  description: 'Comprehensive structural integrity assessments and maintenance for metro infrastructure.',
  icon: 'Building2'
},
{
  id: 2,
  title: 'Waterproofing & Leakage Repairs',
  description: 'Advanced waterproofing solutions and leak detection for underground metro facilities.',
  icon: 'Droplets'
},
{
  id: 3,
  title: 'Finishing & Architectural Maintenance',
  description: 'Aesthetic and functional maintenance of interior and exterior finishes.',
  icon: 'Paintbrush'
},
{
  id: 4,
  title: 'Staircases, Escalator Pits & Lift Shafts',
  description: 'Specialized maintenance for vertical transportation infrastructure and access points.',
  icon: 'MoveVertical'
},
{
  id: 5,
  title: 'Substructure & Underground Works Maintenance',
  description: 'Expert underground structural maintenance ensuring safety and longevity.',
  icon: 'Construction'
},
{
  id: 6,
  title: 'Planned Preventive Maintenance (PPM) Activities',
  description: 'Scheduled maintenance programs to prevent issues and ensure continuous operation.',
  icon: 'Calendar'
}];


export const clients = [
  { id: 1, name: 'Blue Dart', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/yqox6fff_blue-dart-logo-png_seeklogo-264891.png' },
  { id: 2, name: 'Air India SATS', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/mu0v4mal_air-india-logo.webp' },
  { id: 3, name: 'DHL', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/kcpkp7eh_dhl-1.svg' },
  { id: 4, name: 'The Ottera Hotel', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/bu56me6y_oooouiuio.png' },
  { id: 5, name: 'BIAL - Bangalore International Airport', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/i7jl74de_mgcjghkgh.png' },
  { id: 6, name: 'Bangalore Metro Rail Corporation (BMRCL)', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/kybqlud5_jnnvff.png' },
  { id: 7, name: 'L&T Construction', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/kq84p2ai_logo.avif' },
  { id: 8, name: 'Brigade Group', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/zj1m3n6v_ncccl-india-logo.png' },
  { id: 9, name: 'Avasarala Technologies', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/uqe931su_footer_logo.jpg' },
  { id: 10, name: 'Ashok Leyland', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/ovyqwf22_Ashok_Leyland-Logo.wine.svg' },
  { id: 11, name: 'Embassy Group', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/gn73a1z5_Strides-Arcolab-Ltd.svg.webp' },
  { id: 12, name: 'Shapoorji Pallonji', logo: 'https://customer-assets.emergentagent.com/job_profab-steel/artifacts/oe1hcr13_images%20%281%29.png' }
];
